import React, { useEffect } from 'react'
import styled from 'styled-components'
import { MyWorkContainer } from '../../components'
import { Title } from '../../assets/styles/commonStyles'
import { useContext } from 'react'
import authContext from '../../context/auth-context'
import { ToastContainer } from 'react-toastify'
import { url } from '../../constants'

const AboutMeWrapper = styled.div`
    box-shadow: #ffd7002e 0px 0px 32px -1px inset;
    background: transparent !important;
    margin: 47px;
    padding: 40px;
    margin-top:50px;
    div{
      background:transparent !important;
      padding:20px 100px;
      display:flex;
      flex-direction:row;
      justify-content:center;
      margin-top:40px;
      h5{
        background:transparent !important;
        color:white;
        font-weight:400;
        letter-spacing:1.1px;
        font-size:18px;
        text-transform:capitalize;
        line-height:30px;
      }
    }
    @media screen and (max-width:768px){
      box-shadow: #ffd7002e 0px 0px 32px -1px;
      border-radius:10px;
      div{
        padding: 20px 30px;
        h5{
          text-align:center;
        }
      }
    }
    @media screen and (max-width:500px){
      box-shadow: #ffd7002e 0px 0px 32px -1px;
      border-radius:10px;
      margin: 40px 14px;
      div{
        padding: 2px;
        h5{
          text-align:start;
          font-size:16px;
        }
      }
    }
`
const HideOnMobile = styled.div`
    display: flex;
    flex-direction:column;
    @media screen and (max-width:500px){
      display: none !important;
      visibility: hidden;
    }
`

const AboutMe = () => {
  const {state, getAboutMe, getContent} = useContext(authContext)
  useEffect(()=>{
    if(state?.aboutme === undefined){
      getAboutMe()
      getContent()
    }
    // eslint-disable-next-line
  },[])
  return (
    <>
    <AboutMeWrapper>
        <Title className='fade-in-up'>ABOUT ME</Title>
      <div>
        <h5>
          {state?.aboutme?.data?.[0]?.message}
        </h5>
      </div>
    </AboutMeWrapper>
    <HideOnMobile>
      {state?.content?.map((item, index)=> (
          <MyWorkContainer 
            key={item.id}
            image={`${url}${item.image}`}
            imageLast={index % 2 === 0}
            imageAlt={item.title}
            title={item.title}
            desc={item.description}
            url={item.playlistLink}
            />
        ))}
    </HideOnMobile>
    <ToastContainer
      position="bottom-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{textAlign:'center'}}
      />
    </>
  )
}

export default AboutMe